<template>
  <div class="chart-bar">
    <div class="title">
      <span>{{ tabIndex === 0 ? '广东省科创企业地市分布情况' : '广东省百强企业地市分布情况' }}</span>
      <div>
        <ElementSelect
          :val="year"
          :options="yearOptions"
          @val="
            (e) => {
              year = e;
            }
          "
        />
        <span id="btn-link">关联地图展示</span>
      </div>
    </div>
    <div class="chart-con">
      <TabList
        class="po"
        :list="tabList"
        :act="tabIndex"
        @clickItem="
          (item, i) => {
            tabIndex = i;
          }
        "
      ></TabList>
      <v-chart ref="bar-chart" :id="chartId" class="bar-chart" :options="chartOption" />
    </div>
  </div>
</template>

<script>
import drawBar from '../chartJs/bar';
import { getBarData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
import ElementSelect from '../../../components/element-select';
import echarts from 'echarts';
import tmpData from '@/views/home/tmpData';
export default {
  name: 'ChartBar',
  components: { TabList, ElementSelect },
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    apiName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      chartOption: null,
      chartData: null,
      tabList: [
        {
          key: 0,
          label: '科创企业',
        },
        {
          key: 1,
          label: '百强企业',
        },
      ],
      tabIndex: 0,
      year: 2021,
      yearOptions: [],
    };
  },
  watch: {
    year() {
      this.$nextTick(() => {
        this.getData();
      });
    },
    tabIndex() {
      this.$nextTick(() => {
        this.getData();
      });
    },
  },
  methods: {
    getData() {
      let data = this.tabIndex
        ? tmpData['广东省百强企业地市分布情况']
        : tmpData['广东省科创企业地市分布情况'].filter((x) => x['地市'] !== '广东省');

      let yearTemp = data.map((x) => x['年份']);
      this.yearOptions = yearTemp
        .filter((item, index) => {
          return yearTemp.indexOf(item) === index;
        })
        .map((x) => ({
          value: x,
          label: x,
        }));
      let arr = tmpData.addr.map((x) => ({
        name: x,
      }));
      data
        .filter((x) => x['年份'] === this.year)
        .map((item) => {
          tmpData.addr.map((y, i) => {
            if (y === item['地市'].slice(0, -1)) {
              arr[i].value = this.tabIndex ? item['计数'] : item['企业数量'];
            }
          });
        });
      console.log(123123, arr);
      let list = {
        data: arr,
        names: ['总数'],
        yAxis: {
          name: '单位：家',
        },
      };
      this.chartData = list;
      this.chartOption = drawBar(list);
      return;
      if (!this.name) return;
      let chart = echarts.init(document.getElementById(this.chartId));
      this.$api.screen[this.apiName]({
        endYear: this.yearP,
      }).then((res) => {
        let { data } = res.data;
        let names = [],
          listData = {};
        if (data && data.yData?.length) {
          names = data.yData.map((item) => {
            listData[item.name] = item.data;
            return item.name;
          });
          listData['年份'] = data.xData;
        }
        let list = {
          yAxis: {
            name: '单位：' + (this.name === 'specialNew' || this.name === 'highTech' ? '家' : '亿元'),
          },
          names: ['总数'],
          // colorOpacity: true,
          data: [],
        };
        if (this.type === 'multi') {
          list.names = names;
          list.showLabel = this.showLabel;
        }
        for (let i = 0; i < data.xData.length; i++) {
          let obj = {
            年份: data.xData[i],
          };
          for (let key in listData) {
            obj[key] = listData[key][i];
          }
          list.data.push(obj);
        }
        this.chartData = list;
        this.chartOption = drawBar(list);

        let _this = this;
        chart.on('click', function (params) {
          _this.$emit('click-chart', params);
        });
      });

      // getBarData(this.name).then(res => {
      //   let year = new Set();
      //   let names = new Set();
      //   let data = [];
      //   res.RECORDS.map((item) => {
      //     year.add(item['年份']);
      //     names.add(item['指标']);
      //     data.push(item['总数'])
      //   });
      //
      //   this.$nextTick(() => {
      //     let list = {
      //       yAxis: {
      //         name: '单位：' + (this.name === 'specialNew' || this.name === 'highTech' ? '家' : '亿元')
      //       },
      //       names: ['总数'],
      //       // colorOpacity: true,
      //       data: []
      //     };
      //     let dataObj = {};
      //     year = Array.from(year)
      //     dataObj.year = year;
      //     if (this.type === 'multi') {
      //       names = Array.from(names);
      //       list.names = names;
      //       list.showLabel = this.showLabel;
      //       dataObj.private = this.filterData(res.RECORDS, names[0], '总数', '指标');
      //       dataObj.individual = this.filterData(res.RECORDS, names[1], '总数', '指标');
      //       for (let i = 0; i < dataObj.year.length; i++) {
      //         let obj = {
      //           年份: year[i],
      //         };
      //         obj[names[0]] = dataObj.private[i];
      //         obj[names[1]] = dataObj.individual[i];
      //         list.data.push(obj)
      //       }
      //       this.chartData = list;
      //       this.chartOption = drawBar(list)
      //       return;
      //     }
      //     for (let i = 0; i < year.length; i++) {
      //       list.data.push({
      //         年份: year[i],
      //         总数: data[i]
      //       });
      //     }
      //     this.chartData = list;
      //     this.chartOption = drawBar(list)
      //   })
      // })
    },
    filterData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          arr.push(Number(data[key][keyName]));
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.chart-bar {
  .chart-box();
  .title {
    width: 100%;
    div {
      flex: 1;
      justify-content: flex-end;
      display: inline-flex;
      line-height: 1;
      align-items: center;
      .element-select {
        position: unset;
      }
    }
    #btn-link {
      margin-left: 32px;
    }
  }
}
</style>
